/**
 * Каталог потолков: натяжные (матовый и глянцевый) и гипсокартонный.
 *
 * Опуски — типовые для квартиры: натяжному хватает 50 мм под багет и закладные
 * светильников, гипсокартону нужен каркас из профиля 27 мм на подвесах плюс лист
 * 12,5 мм — обычно 100 мм. Цвет — белый, у гипсокартона чуть теплее: он окрашен.
 * Id элементов — ключи ссылок из инструмента установки, менять нельзя без миграции.
 */
import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import { CeilingMaterial, type CeilingCatalogItem } from "./types";

export const ceilingSection: CatalogSection<CeilingCatalogItem> = {
	kind: LayerKind.Ceiling,
	label: "Потолок",
	canChangeDimensions: false,
	subGroups: ["Натяжной", "Гипсокартон"],
	items: [
		{
			id: "ceiling-stretch-matte",
			material: CeilingMaterial.StretchMatte,
			subGroup: "Натяжной",
			name: "Натяжной матовый",
			description: "ПВХ-плёнка на багете по периметру. Ровный белый потолок без бликов.",
			color: "#f8fafc",
			drop: 50,
			minDrop: 30,
			glossy: false,
		},
		{
			id: "ceiling-stretch-glossy",
			material: CeilingMaterial.StretchGlossy,
			subGroup: "Натяжной",
			name: "Натяжной глянцевый",
			description: "ПВХ-плёнка с глянцем: отражает комнату и визуально её поднимает.",
			color: "#f1f5f9",
			drop: 50,
			minDrop: 30,
			glossy: true,
		},
		{
			id: "ceiling-drywall",
			material: CeilingMaterial.Drywall,
			subGroup: "Гипсокартон",
			name: "Гипсокартонный",
			description:
				"ГКЛ 12,5 мм по каркасу из профиля на подвесах, шпаклёвка и покраска. Можно делать уровни.",
			color: "#f5f3ee",
			drop: 100,
			minDrop: 50,
			glossy: false,
		},
	],
};
